import React from "react";
import ModuleConfig from "Configs/Module";
import { Navigate } from "react-router-dom";

type IProps = {
	isPage?: boolean;
	from: {
		enabled: boolean;
		props?: {
			[key: string]: any;
		};
	};
};

type IState = {};

export default class Module extends React.Component<IProps, IState> {
	public override render(): React.ReactNode | null {
		if (!this.props.from.enabled) return this.props.isPage ? <Navigate to={"/"} /> : null;
		return <>{this.props.children}</>;
	}

	public static get config() {
		return ModuleConfig.getInstance().get().modules;
	}
}
